import React from 'react';
import { Card as CardMantine, MantineRadius, StyleProp } from '@mantine/core';
import { ThemeSystem } from '../../../views/my-learning/dashboard/themeColor';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  radius?: MantineRadius;
  flex?: number;
  h?: number | string;
  pos?: StyleProp<React.CSSProperties['position']>;
  top?: StyleProp<React.CSSProperties['top']>;
  bottom?: StyleProp<React.CSSProperties['bottom']>;
  left?: StyleProp<React.CSSProperties['left']>;
  right?: StyleProp<React.CSSProperties['right']>;
  mah?: StyleProp<React.CSSProperties['maxHeight']>;
  onClick?: () => void;
  theme?: ThemeSystem;
  mx?: number;
  my?: number;
  px?: number;
  py?: number;
  bg?: string;
}

const Card: React.FC<CardProps> = ({
  children,
  radius = 'lg',
  flex,
  h,
  top,
  bottom,
  left,
  right,
  pos,
  mah,
  className,
  theme,
  onClick,
  mx,
  my,
  px,
  py,
  bg
}) => {
  return (
    <CardMantine
      flex={flex}
      h={h}
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      withBorder
      radius={radius}
      pos={pos}
      mah={mah}
      className={className}
      onClick={onClick}
      mx={mx}
      my={my}
      px={px}
      py={py}
      bg={bg}
      style={
        theme
          ? {
              backgroundColor: theme.colors.card,
              border: `1px solid ${
                theme.type === 'dark' ? theme.colors.border : '#dee2e6'
              }`
            }
          : {}
      }
    >
      {children}
    </CardMantine>
  );
};

export default Card;
